export default {
      id: "ic_bilyoner_logo-usage",
      viewBox: "0 0 56 56",
      url: "/" + "images/icons.3.109.2.svg#ic_bilyoner_logo-usage",
      toString: function () {
        return this.url;
      }
    }